import type { Mission } from '../missions.ts'

export const usda: Mission = {
  id: 'usda',
  name: 'U.S. Department of Agriculture',
  short: 'USDA',
  call: "Agriculture",
  kind: 'department',
  url: 'https://www.usda.gov/',
  established: 1862,
  palette: { primary: '#009d57', secondary: '#00285e', accent: '#e9ae11' },
  colorSource: {
    kind: 'seal',
    url: 'https://commons.wikimedia.org/wiki/File:Seal_of_the_U.S._Department_of_Agriculture.svg',
  },
  motif: 'wheat',
  mission: {
    text:
      'We provide leadership on food, agriculture, natural resources, rural development, nutrition, and related issues based on public policy, the best available science, and effective management.',
    url: 'https://www.usda.gov/about-usda/general-information',
  },
  fact: {
    text: 'President Lincoln established USDA in 1862 and called it the "People\'s Department."',
    url: 'https://www.usda.gov/about-usda/general-information',
  },
  seal: {
    file: 'public/seals/usda.png',
    source: 'https://commons.wikimedia.org/wiki/File:Seal_of_the_U.S._Department_of_Agriculture.svg',
  },
  logo: {
    file: 'public/logos/usda.svg',
    source: 'https://commons.wikimedia.org/wiki/File:Logo_of_the_United_States_Department_of_Agriculture.svg',
  },
  media: {
    photos: [
        {
          file: "/media/usda-iowa-farm.jpg",
          small: "/media/usda-iowa-farm-sm.jpg",
          alt: "Aerial view of curving contour strips of grass winding across freshly tilled farm fields in Iowa, with a single tractor at work.",
          title: "Conservation farming in Montgomery County, Iowa",
          creator: "Lynn Betts, USDA Natural Resources Conservation Service",
          source: "https://commons.wikimedia.org/wiki/File:NRCSIA99373_-_Iowa_(3439)(NRCS_Photo_Gallery).jpg",
          license: "Public domain (U.S. government work)",
        },
        {
          file: "/media/usda-whitten-building.jpg",
          small: "/media/usda-whitten-building-sm.jpg",
          alt: "The columned facade of the Jamie L. Whitten Building in fresh snow, framed by bare tree branches.",
          title: "Whitten Building in snow, Washington, D.C., December 5, 2025",
          creator: "Christophe Paul, U.S. Department of Agriculture",
          source: "https://commons.wikimedia.org/wiki/File:Whitten_building_facade_with_snow_in_Washington,_D.C._on_December_5,_2025_-_5.jpg",
          license: "Public domain (U.S. government work)",
        },
    ],
  },
}
